import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import {
  comparablesRangeOptions,
  propertyTypeList,
} from '@smartflip/data-constants';
import { filterControlMetadata } from '@smartflip/data-field-configuration';
import { FieldConfig } from '@smartflip/data-models';
import {
  comparablesFilterDescription,
  defaultMinYearBuilt,
} from '../comparables.constants';

@Component({
  selector: 'smartflip-comparables-filter',
  templateUrl: './comparables-filter.component.html',
  styleUrls: ['./comparables-filter.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, IonicModule],
})
export class ComparablesFilterComponent {
  @Input() filterData: any;

  public comparablesFilterDescription = comparablesFilterDescription;
  public filterForm!: UntypedFormGroup;
  public filterControlData!: FieldConfig[];
  public propertyTypes = propertyTypeList;
  public comparablesRangeOptions = comparablesRangeOptions;
  public currentYear = new Date().getFullYear();
  public defaultMinYearBuilt = defaultMinYearBuilt;

  constructor(
    private modalController: ModalController,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    const groupObject = Object.keys(filterControlMetadata).reduce(
      (formGrp, key) => ({ ...formGrp, [key]: [this.filterData?.[key] || ''] }),
      {},
    );
    this.filterForm = this.fb.group(groupObject);
    this.filterControlData = Object.entries(filterControlMetadata).map(
      ([key, value]) =>
        ({ name: key, label: value.label, type: value.type }) as FieldConfig,
    );
  }

  public isDateRangeFilter(name: string): boolean {
    return name === 'dateRange';
  }

  public isMaxYearBuiltFilter(name: string): boolean {
    return name === 'maxYearBuilt';
  }

  public isNotMinYearBuiltFilter(name: string): boolean {
    return name !== 'minYearBuilt';
  }

  public onRangeChange(event: CustomEvent) {
    this.filterForm.patchValue({
      minYearBuilt: event.detail.value.lower,
      maxYearBuilt: event.detail.value.upper,
    });
  }

  public cancel() {
    this.modalController.dismiss();
  }

  public clearFilter() {
    this.filterForm.reset();
  }

  public saveFilter() {
    this.modalController.dismiss(this.filterForm.value);
  }
}
